const baseUrl = 'profile';

export const ApiProfile = {
  Profile: baseUrl,
  ProfilePicture: `${baseUrl}/picture`,
  Contact: `${baseUrl}/contact`,
  Address: `${baseUrl}/address`,
  ProfileLinking: `${baseUrl}/linking`,
  // BU-20433 - was GET profile/linking?nric=...&linkingType=...&lovedOne=...; moved to a POST
  // body on its own sub-path since POST profile/linking above is already the create/link route.
  ProfileLinkingQuery: `${baseUrl}/linking/query`,
  ResendCode: `${baseUrl}/referral-code/send`,
  // BU-20433 - was GET profile/nric/{nric} (NRIC in the URL path); now POST with nric in the body.
  GetProfileByNric: `${baseUrl}/nric`,
  // BU-20810 / BU-20365 - existing-user migration steering
  MigrationStatus: `${baseUrl}/migration-status`,
  // BU-20814 / BU-20480 - eGiro autofill context for the currently-selected profile
  ActiveContext: `${baseUrl}/me/active-context`
};
